import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { PriceDisplay } from 'dibs-buyer-price';
import { Link } from 'dibs-elements/exports/Link';
import { FormattedMessage } from 'dibs-react-intl';
import { PdpSharedAuctionViewHistory } from '../PdpSharedAuctionViewHistory/PdpSharedAuctionViewHistory';

// types
import { PdpSharedAuctionClosed_item$key as Item } from './__generated__/PdpSharedAuctionClosed_item.graphql';

// styles
import styles from './PdpSharedAuctionClosed.scss';

type Props = {
    item: Item;
    currency: string;
    linkToAuctions?: boolean;
    linkToBidHistory?: boolean;
};

const itemFragment = graphql`
    fragment PdpSharedAuctionClosed_item on Item {
        ...PriceDisplay_item @arguments(userId: $userId, isTrade: $isTrade)
    }
`;

export const PdpSharedAuctionClosed: FC<Props> = ({
    item: itemRef,
    currency,
    linkToAuctions,
    linkToBidHistory,
}) => {
    const item = useFragment(itemFragment, itemRef);

    return (
        <div className={styles.container}>
            <span className={styles.closed}>
                <FormattedMessage
                    id="PdpSharedAuctionClosed.biddingClosed"
                    defaultMessage="Bidding Closed"
                />
            </span>
            <span className={styles.price}>
                <PriceDisplay currency={currency} item={item} useSvgIcon />
            </span>
            {linkToAuctions && (
                <Link href="/auctions/" className={styles.link}>
                    <FormattedMessage
                        id="PdpRespAuctionInfo.browse"
                        defaultMessage="Browse Current Auctions"
                    />
                </Link>
            )}
            {linkToBidHistory && <PdpSharedAuctionViewHistory currency={currency} />}
        </div>
    );
};
